import { queryOptions } from '@tanstack/react-query';
import { adminClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { apiBaseUrl } from '../env';

/**
 * The Better Auth client, for sign-in, sign-out and password flows only
 * (ADR 0003). adminClient() is here for the `role` on the session type; admin
 * actions on users go through our /admin endpoints, never /auth/admin/*,
 * which the API refuses from a browser.
 */
export const authClient = createAuthClient({
  baseURL: apiBaseUrl,
  basePath: '/auth',
  fetchOptions: { credentials: 'include' },
  plugins: [adminClient()],
});

/**
 * The session, cached for the shell's route guard. The cookie is shared with
 * app., so one browser has one signed-in user; the back office only lets
 * ADMIN through, and the API checks the role again on every request.
 */
export const sessionQuery = queryOptions({
  queryKey: ['auth', 'session'],
  queryFn: async () => {
    const { data, error } = await authClient.getSession();
    if (error !== null) throw new Error(`Session check failed with ${error.status}`);
    return data;
  },
  staleTime: 60_000,
});

/** A path inside the back office, or null. Keeps /login from being an open redirect. */
export function safeRedirect(raw: string | undefined): string | null {
  if (raw === undefined || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return null;
  return raw;
}
